import * as React from "react";
import type { SVGProps } from "react";
const SvgTennisball = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#tennisball_svg__a)">
      <path
        fill="currentColor"
        d="M20 10c0-2.91-1.26-5.53-3.25-7.35v-.01c-.01-.01-.03-.02-.04-.03C14.93 1 12.59.01 10.01.01S5.07.99 3.29 2.6c-.01.01-.03.02-.04.03v.01C1.26 4.47 0 7.09 0 10s1.26 5.53 3.25 7.35v.01c.01.01.02.01.04.03C5.07 19 7.42 20 10 20s4.93-.99 6.71-2.61c.01-.01.03-.01.04-.03v-.01C18.74 15.52 20 12.91 20 10m-2 0c0 2.02-.76 3.86-2 5.27-2.67-3.04-2.62-7.57 0-10.55 1.24 1.41 2 3.25 2 5.27zM2 10c0-2.02.76-3.86 2-5.27 2.61 2.98 2.67 7.5 0 10.55-1.24-1.41-2-3.25-2-5.27zm3.49 6.6c3.35-3.81 3.28-9.48 0-13.21 1.28-.88 2.84-1.4 4.51-1.4s3.22.52 4.51 1.4c-3.28 3.73-3.35 9.4 0 13.21-1.28.88-2.84 1.4-4.51 1.4s-3.22-.52-4.51-1.4"
      />
    </g>
    <defs>
      <clipPath id="tennisball_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTennisball;
